import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { BoxContainer } from "./styles";

ChartJS.register(ArcElement, Tooltip, Legend);

const centeredTextPlugin = {
  id: "centeredText",
  beforeDraw: (chart, args, options) => {
    const { width, height, ctx } = chart;
    ctx.restore();

    // Set styles for the "52%" text
    ctx.font = "bold 16px sans-serif"; // Larger font size
    ctx.fillStyle = "#00695f"; // Color for "52%"

    const percentageText = options.centerText;
    const textX = Math.round(
      (width - ctx.measureText(percentageText).width) / 2
    ); // Center horizontally
    const textY = height / 2.2 - 10; // Adjust for vertical centering

    ctx.fillText(percentageText, textX, textY);

    // Set styles for the remaining text
    ctx.font = "14px sans-serif"; // Smaller font size
    ctx.fillStyle = "#009688"; // Color for "scheduled or completed"

    const additionalText = "Scheduled\nor Completed";
    const lines = additionalText.split("\n");

    // Position remaining text slightly below the percentage
    lines.forEach((line, index) => {
      const lineTextX = Math.round((width - ctx.measureText(line).width) / 2);
      const lineHeight = 20;
      const lineTextY = textY + 10 + (index + 1) * lineHeight; // Offset below percentage
      ctx.fillText(line, lineTextX, lineTextY);
    });

    ctx.save();
  },
};

const DonutChart = () => {
  const data = {
    labels: [
      "Visits Completed",
      "Ready to Complete",
      "Upcoming Appointments",
      "To Be Scheduled",
    ],
    datasets: [
      {
        label: "Preventative Visit Progress",
        data: [19, 1, 2, 18],
        backgroundColor: ["#00695f", "#009688", "#4dd0e1", "#b2ebf2"],
        hoverBackgroundColor: ["#004d40", "#00796b", "#26c6da", "#80deea"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    cutout: "70%",
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      centeredText: {
        centerText: "63%",
      },
    },
  };

  return (
    <BoxContainer>
      <Doughnut
        data={data}
        options={{ ...options }}
        plugins={[centeredTextPlugin]}
      />
    </BoxContainer>
  );
};

export default DonutChart;
